import { MetadataOptionsQuestion, NumberQuestion } from '../../../types';
import { QuestionInterface } from '../../../types/oldWebForms';
import { reBuildQuestion } from '../reBuildQuestion';

export const deleteAssociatedMetadata = (
  questionIds: string[],
  tableId: string | undefined,
  questions: QuestionInterface[],
) => {
  return questionIds.reduce((acc, questionId) => {
    return reBuildQuestion(
      (question: MetadataOptionsQuestion | NumberQuestion) => {
        delete question.associatedMetadata;
        return question;
      },
      questionId,
      tableId,
    )(acc);
  }, questions);
};
